<div class="p-3">
    <app-wizard-head [wizardInput]="wizardInput"></app-wizard-head>
</div>
<div class="p-3" *ngIf="!isManageLca">
    <lib-lca-soc-code-library (onDeleteLca)="onDeleteLCA($event)" *ngIf="inputData?.taskId" [isWizardFlag]="true" [compId]="companyId" [primaryData]="inputData" [simplifyH1b]="false" style="width:100%"></lib-lca-soc-code-library>
</div>
<router-outlet></router-outlet>